export enum TemplateSortField {
  TITLE = 'title',
  UPDATED_AT = 'updatedAt',
  CREATED_BY = 'user.name'
}
